import { defineComponent as _defineComponent } from 'vue';
import { withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/calendar/today.png';
import _imports_1 from '@/assets/img/calendar/pauseVideo.png';
const _withScopeId = n => (_pushScopeId("data-v-3aa343d3"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "calendarPage" };
const _hoisted_2 = { class: "tabWrapper" };
const _hoisted_3 = {
    key: 0,
    class: "calendarList"
};
const _hoisted_4 = {
    key: 0,
    class: "todayBox flex"
};
const _hoisted_5 = { class: "todayNum" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "line" }, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "todayImg",
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_8 = {
    key: 1,
    class: "calendarDate"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "calendarTitle" };
const _hoisted_11 = { class: "calendarContent" };
const _hoisted_12 = {
    class: "calendarCover",
    alt: ""
};
const _hoisted_13 = { class: "calendarLeft" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "calendarLable" }, "知识点来源", -1));
const _hoisted_15 = { class: "lecturerName" };
const _hoisted_16 = { class: "hospital" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "pauseVideo",
    src: _imports_1
}, null, -1));
const _hoisted_18 = { class: "noMore" };
import { getCalendarList, getBookmarkList } from '@api/canlendar';
import Header from '@/components/common/Header.vue';
import BScroll from '@/components/common/BetterScroll.vue';
import { isLogin, hiddenAppNavBar, getUserId, appPort, jumpModuleApp, closeWebView, weixinShare } from '@/widget/index';
import Empty from '@/components/common/Empty.vue';
import { hostPath } from '@utils/basePath';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        var now = new Date();
        var nowDate = now.getDate();
        const route = useRoute();
        const userId = getUserId();
        const currentTab = ref('All');
        const isApp = ref(appPort());
        const departmentId = Number(route.query.depId || 1);
        let shareInfo = {
            title: '好医术2023知识点日历',
            desc: '精选365个课程知识点，结合名师解析助您高效成长！',
            url: location.href,
            image: 'https://img-a.haoyishu.com/images/share/hys_logo.png'
        };
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        /* 切换tab */
        const selectTab = tabVal => {
            if (tabVal != currentTab.value) {
                pageNo = 1;
                pageCount = 1;
                list.value = [];
            }
            else {
                return;
            }
            currentTab.value = tabVal;
            getLists();
        };
        // app 分享
        /* const shareFn = () => {
          if (isApp.value) {
            appShare(shareInfo)
          } else {
            weixinShare(shareInfo)
          }
        } */
        const goDetail = (id, albumId) => {
            const url = `/learn/calendar/detail/${id}`;
            if (isApp.value) {
                jumpModuleApp({
                    typeId: 'h5',
                    url: `${hostPath}${url}`
                });
            }
            else {
                location.href = url;
            }
        };
        const loaded = ref(false);
        const noMore = ref(false);
        var pageNo = 1;
        var pageCount = 1;
        const list = ref([]);
        /* 日历列表 */
        const getList = () => {
            loaded.value = false;
            getCalendarList(departmentId, {
                pageNo: pageNo,
                pageSize: 10,
                userId
            }).then(res => {
                loaded.value = true;
                if (res.code === 200) {
                    pageCount = res.data.pageCount;
                    let { desc, title, image } = res.data.list.share;
                    shareInfo.desc = desc;
                    shareInfo.title = title;
                    shareInfo.image = image;
                    if (!isApp.value) {
                        weixinShare(shareInfo);
                    }
                    if (pageNo >= pageCount) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo++;
                    }
                    if (pageNo == 1) {
                        list.value = res.data.list.hysCalendarList;
                    }
                    else {
                        list.value = list.value.concat(res.data.list.hysCalendarList);
                    }
                }
            });
        };
        /* 日历收藏列表 */
        const getBookmark = () => {
            loaded.value = false;
            if (!isLogin) {
                list.value = [];
            }
            else {
                getBookmarkList(userId, {
                    depId: departmentId,
                    pageNo: pageNo,
                    pageSize: 10
                }).then(res => {
                    loaded.value = true;
                    if (res.code === 200) {
                        pageCount = res.data.pageCount;
                        list.value = res.data.list;
                        if (pageNo == 1) {
                            list.value = res.data.list;
                        }
                        else {
                            list.value = list.value.concat(res.data.list);
                        }
                        if (pageNo >= pageCount) {
                            noMore.value = true;
                        }
                        else {
                            noMore.value = false;
                            pageNo++;
                        }
                    }
                });
            }
        };
        getList();
        // 上拉加载
        const listBs = ref();
        const getLists = () => {
            if (currentTab.value === 'All') {
                getList();
            }
            else {
                getBookmark();
            }
            listBs.value.refreshBs();
        };
        if (isApp.value) {
            hiddenAppNavBar();
        }
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isApp.value)
                    ? (_openBlock(), _createBlock(Header, {
                        key: 0,
                        onBackFn: backFn,
                        showBack: true,
                        isColor: true
                    }, {
                        shareBtn: _withCtx(() => []),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["tab", { inApp: isApp.value }])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["tab-item", { active: currentTab.value == 'All' }]),
                            onClick: _cache[0] || (_cache[0] = ($event) => (selectTab('All')))
                        }, " 全部 ", 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["tab-item", { active: currentTab.value == 'Collection' }]),
                            onClick: _cache[1] || (_cache[1] = ($event) => (selectTab('Collection')))
                        }, " 我的收藏 ", 2)
                    ], 2)
                ]),
                _createVNode(BScroll, {
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                        listBs.value = _value;
                    },
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: true,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    loaded: loaded.value,
                    noMore: noMore.value,
                    onUpLoad: getLists,
                    domStyle: {
                        position: 'relative',
                        height: isApp.value ? 'calc(100vh - 1.78rem)' : 'calc(100vh - 0.9rem)'
                    }
                }, {
                    default: _withCtx(() => [
                        (list.value.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                        (index === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(nowDate)), 1),
                                                _hoisted_6,
                                                _hoisted_7
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.calendarDate), 1)),
                                        _createElementVNode("div", {
                                            class: "calendarBox",
                                            onClick: _withModifiers(($event) => (goDetail(item.calendarId, item.albumId)), ["stop"])
                                        }, [
                                            _createElementVNode("p", _hoisted_10, _toDisplayString(item.albumName), 1),
                                            _createElementVNode("div", _hoisted_11, [
                                                _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                                                    [_directive_lazy, item.imgUrl]
                                                ]),
                                                _createElementVNode("div", _hoisted_13, [
                                                    _hoisted_14,
                                                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.expertName), 1),
                                                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.hospitalName), 1)
                                                ]),
                                                _hoisted_17
                                            ])
                                        ], 8, _hoisted_9)
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createBlock(Empty, { key: 1 })),
                        _withDirectives(_createElementVNode("div", _hoisted_18, "没有更多了", 512), [
                            [_vShow, noMore.value && list.value.length !== 0]
                        ])
                    ]),
                    _: 1
                }, 8, ["loaded", "noMore", "domStyle"])
            ]));
        };
    }
});
